type CountryTranslations = {
    [languageCode: string]: string;
};

export type Countries = {
    [countryCode: string]: CountryTranslations;
};

const COSTA_RICA = "Costa Rica";
const EL_SALVADOR = "El Salvador";

export const COUNTRIES: Countries = {
    AGO: {
        en: "Angola",
        de: "Angola",
        es: "Angola",
        fr: "Angola",
        it: "Angola",
        nl: "Angola",
    },
    ARE: {
        en: "United Arab Emirates",
        de: "Vereinigte Arabische Emirate",
        es: "Emiratos Árabes Unidos",
        fr: "Émirats arabes unis",
        it: "Emirati Arabi Uniti",
        nl: "Verenigde Arabische Emiraten",
    },
    ARG: {
        en: "Argentina",
        de: "Argentinien",
        es: "Argentina",
        fr: "Argentine",
        it: "Argentina",
        nl: "Argentinië",
    },
    AUS: {
        en: "Australia",
        de: "Australien",
        es: "Australia",
        fr: "Australie",
        it: "Australia",
        nl: "Australië",
    },
    AUT: {
        en: "Austria",
        de: "Österreich",
        es: "Austria",
        fr: "Autriche",
        it: "Austria",
        nl: "Oostenrijk",
    },
    AZE: {
        en: "Azerbaijan",
        de: "Aserbaidschan",
        es: "Azerbaiyán",
        fr: "Azerbaïdjan",
        it: "Azerbaigian",
        nl: "Azerbeidzjan",
    },
    BGD: {
        en: "Bangladesh",
        de: "Bangladesch",
        es: "Bangladés",
        fr: "Bangladesh",
        it: "Bangladesh",
        nl: "Bangladesh",
    },
    BEL: {
        en: "Belgium",
        de: "Belgien",
        es: "Bélgica",
        fr: "Belgique",
        it: "Belgio",
        nl: "België",
    },
    BGR: {
        en: "Bulgaria",
        de: "Bulgarien",
        es: "Bulgaria",
        fr: "Bulgarie",
        it: "Bulgaria",
        nl: "Bulgarije",
    },
    BHR: {
        en: "Bahrain",
        de: "Bahrain",
        es: "Baréin",
        fr: "Bahreïn",
        it: "Bahrain",
        nl: "Bahrein",
    },
    BRA: {
        en: "Brazil",
        de: "Brasilien",
        es: "Brasil",
        fr: "Brésil",
        it: "Brasile",
        nl: "Brazilië",
    },
    CAN: {
        en: "Canada",
        de: "Kanada",
        es: "Canadá",
        fr: "Canada",
        it: "Canada",
        nl: "Canada",
    },
    CHL: {
        en: "Chile",
        de: "Chile",
        es: "Chile",
        fr: "Chili",
        it: "Cile",
        nl: "Chili",
    },
    CHN: {
        en: "China",
        de: "China",
        es: "China",
        fr: "Chine",
        it: "Cina",
        nl: "China",
    },
    CHE: {
        en: "Switzerland",
        de: "Schweiz",
        es: "Suiza",
        fr: "Suisse",
        it: "Svizzera",
        nl: "Zwitserland",
    },
    COL: {
        en: "Colombia",
        de: "Kolumbien",
        es: "Colombia",
        fr: "Colombie",
        it: "Colombia",
        nl: "Columbia",
    },
    CRI: {
        en: "Costa Rica",
        de: COSTA_RICA,
        es: COSTA_RICA,
        fr: COSTA_RICA,
        it: COSTA_RICA,
        nl: COSTA_RICA,
    },
    CYP: {
        en: "Cyprus",
        de: "Zypern",
        es: "Chipre",
        fr: "Chypre",
        it: "Cipro",
        nl: "Cyprus",
    },
    CZE: {
        en: "Czech Republic",
        de: "Tschechische Republik",
        es: "República Checa",
        fr: "République tchèque",
        it: "Repubblica Ceca",
        nl: "Tsjechië",
    },
    DOM: {
        en: "Dominican Republic",
        de: "Dominikanische Republik",
        es: "República Dominicana",
        fr: "République Dominicaine",
        it: "Repubblica Dominicana",
        nl: "Dominicaanse Republiek",
    },
    DEU: {
        en: "Germany",
        de: "Deutschland",
        es: "Alemania",
        fr: "Allemagne",
        it: "Germania",
        nl: "Duitsland",
    },
    DNK: {
        en: "Denmark",
        de: "Dänemark",
        es: "Dinamarca",
        fr: "Danemark",
        it: "Danimarca",
        nl: "Denemarken",
    },
    ECU: {
        en: "Ecuador",
        de: "Ecuador",
        es: "Ecuador",
        fr: "Equateur",
        it: "Ecuador",
        nl: "Ecuador",
    },
    EGY: {
        en: "Egypt",
        de: "Ägypten",
        es: "Egipto",
        fr: "Égypte",
        it: "Egitto",
        nl: "Egypte",
    },
    ESP: {
        en: "Spain",
        de: "Spanien",
        es: "España",
        fr: "Espagne",
        it: "Spagna",
        nl: "Spanje",
    },
    EST: {
        en: "Estonia",
        de: "Estland",
        es: "Estonia",
        fr: "Estonie",
        it: "Estonia",
        nl: "Estland",
    },
    FIN: {
        en: "Finland",
        de: "Finnland",
        es: "Finlandia",
        fr: "Finlande",
        it: "Finlandia",
        nl: "Finland",
    },
    FRA: {
        en: "France",
        de: "Frankreich",
        es: "Francia",
        fr: "France",
        it: "Francia",
        nl: "Frankrijk",
    },
    GHA: {
        en: "Ghana",
        de: "Ghana",
        es: "Ghana",
        fr: "Ghana",
        it: "Ghana",
        nl: "Ghana",
    },
    GBR: {
        en: "United Kingdom",
        de: "Vereinigtes Königreich",
        es: "Reino Unido",
        fr: "Royaume-Uni",
        it: "Regno Unito",
        nl: "Verenigd Koninkrijk",
    },
    GRC: {
        en: "Greece",
        de: "Griechenland",
        es: "Grecia",
        fr: "Grèce",
        it: "Grecia",
        nl: "Griekenland",
    },
    HUN: {
        en: "Hungary",
        de: "Ungarn",
        es: "Hungría",
        fr: "Hongrie",
        it: "Ungheria",
        nl: "Hongarije",
    },
    HKG: {
        en: "Hong Kong",
        de: "Hongkong",
        es: "Hong Kong",
        fr: "Hong Kong",
        it: "Hong Kong",
        nl: "Hongkong",
    },
    HRV: {
        en: "Croatia",
        de: "Kroatien",
        es: "Croacia",
        fr: "Croatie",
        it: "Croazia",
        nl: "Kroatie",
    },
    IDN: {
        en: "Indonesia",
        de: "Indonesien",
        es: "Indonesia",
        fr: "Indonésie",
        it: "Indonesia",
        nl: "Indonesië",
    },
    IND: {
        en: "India",
        de: "Indien",
        es: "India",
        fr: "Inde",
        it: "India",
        nl: "India",
    },
    IRL: {
        en: "Ireland",
        de: "Irland",
        es: "Irlanda",
        fr: "Irlande",
        it: "Irlanda",
        nl: "Ierland",
    },
    ISL: {
        en: "Iceland",
        de: "Island",
        es: "Islandia",
        fr: "Islande",
        it: "Islanda",
        nl: "IJsland",
    },
    ISR: {
        en: "Israel",
        de: "Israel",
        es: "Israel",
        fr: "Israël",
        it: "Israele",
        nl: "Israël",
    },
    ITA: {
        en: "Italy",
        de: "Italien",
        es: "Italia",
        fr: "Italie",
        it: "Italia",
        nl: "Italië",
    },
    JAM: {
        en: "Jamaica",
        de: "Jamaika",
        es: "Jamaica",
        fr: "Jamaïque",
        it: "Giamaica",
        nl: "Jamaica",
    },
    JPN: {
        en: "Japan",
        de: "Japan",
        es: "Japón",
        fr: "Japon",
        it: "Giappone",
        nl: "Japan",
    },
    JOR: {
        en: "Jordan",
        de: "Jordanien",
        es: "Jordania",
        fr: "Jordanie",
        it: "Giordania",
        nl: "Jordanie",
    },
    KAZ: {
        en: "Kazakhstan",
        de: "Kasachstan",
        es: "Kazajistán",
        fr: "Kazakhstan",
        it: "Kazakistan",
        nl: "Kazachstan",
    },
    KEN: {
        en: "Kenya",
        de: "Kenia",
        es: "Kenia",
        fr: "Kenya",
        it: "Kenya",
        nl: "Kenia",
    },
    KOR: {
        en: "South Korea",
        de: "Südkorea",
        es: "Corea del Sur",
        fr: "Corée du Sud",
        it: "Corea del Sud",
        nl: "Zuid-Korea",
    },
    KWT: {
        en: "Kuwait",
        de: "Kuwait",
        es: "Kuwait",
        fr: "Koweït",
        it: "Kuwait",
        nl: "Koeweit",
    },
    LKA: {
        en: "Sri Lanka",
        de: "Sri Lanka",
        es: "Sri Lanka",
        fr: "Sri Lanka",
        it: "Sri Lanka",
        nl: "Sri Lanka",
    },
    LUX: {
        en: "Luxembourg",
        de: "Luxemburg",
        es: "Luxemburgo",
        fr: "Luxembourg",
        it: "Lussemburgo",
        nl: "Luxemburg",
    },
    LVA: {
        en: "Latvia",
        de: "Lettland",
        es: "Letonia",
        fr: "Lettonie",
        it: "Lettonia",
        nl: "Letland",
    },
    LTU: {
        en: "Lithuania",
        de: "Litauen",
        es: "Lituania",
        fr: "Lituanie",
        it: "Lituania",
        nl: "Litouwen",
    },
    MAR: {
        en: "Morocco",
        de: "Marokko",
        es: "Marruecos",
        fr: "Maroc",
        it: "Marocco",
        nl: "Marokko",
    },
    MEX: {
        en: "Mexico",
        de: "Mexiko",
        es: "México",
        fr: "Mexique",
        it: "Messico",
        nl: "Mexico",
    },
    MLT: {
        en: "Malta",
        de: "Malta",
        es: "Malta",
        fr: "Malta",
        it: "Malta",
        nl: "Malta",
    },
    MYS: {
        en: "Malaysia",
        de: "Malaysia",
        es: "Malasia",
        fr: "Malaisie",
        it: "Malesia",
        nl: "Maleisië",
    },
    NGA: {
        en: "Nigeria",
        de: "Nigeria",
        es: "Nigeria",
        fr: "Nigeria",
        it: "Nigeria",
        nl: "Nigeria",
    },
    NLD: {
        en: "Netherlands",
        de: "Niederlande",
        es: "Países Bajos",
        fr: "Pays-Bas",
        it: "Paesi Bassi",
        nl: "Nederland",
    },
    NOR: {
        en: "Norway",
        de: "Norwegen",
        es: "Noruega",
        fr: "Norvège",
        it: "Norvegia",
        nl: "Noorwegen",
    },
    NZL: {
        en: "New Zealand",
        de: "Neuseeland",
        es: "Nueva Zelanda",
        fr: "Nouvelle-Zélande",
        it: "Nuova Zelanda",
        nl: "Nieuw-Zeeland",
    },
    OMN: {
        en: "Oman",
        de: "Oman",
        es: "Oman",
        fr: "Oman",
        it: "Oman",
        nl: "Oman",
    },
    PAK: {
        en: "Pakistan",
        de: "Pakistan",
        es: "Pakistan",
        fr: "Pakistan",
        it: "Pakistan",
        nl: "Pakistan",
    },
    PAN: {
        en: "Panama",
        de: "Panama",
        es: "Panamá",
        fr: "Panama",
        it: "Panama",
        nl: "Panama",
    },
    PER: {
        en: "Peru",
        de: "Peru",
        es: "Perú",
        fr: "Pérou",
        it: "Perù",
        nl: "Peru",
    },
    PHL: {
        en: "Philippines",
        de: "Philippinen",
        es: "Filipinas",
        fr: "Philippines",
        it: "Filippine",
        nl: "Filipijnen",
    },
    POL: {
        en: "Poland",
        de: "Polen",
        es: "Polonia",
        fr: "Pologne",
        it: "Polonia",
        nl: "Polen",
    },
    PRY: {
        en: "Paraguay",
        de: "Paraguay",
        es: "Paraguay",
        fr: "Paraguay",
        it: "Paraguay",
        nl: "Paraguay",
    },
    PRT: {
        en: "Portugal",
        de: "Portugal",
        es: "Portugal",
        fr: "Portugal",
        it: "Portogallo",
        nl: "Portugal",
    },
    QAT: {
        en: "Qatar",
        de: "Katar",
        es: "Catar",
        fr: "Qatar",
        it: "Qatar",
        nl: "Qatar",
    },
    ROU: {
        en: "Romania",
        de: "Rumanien",
        es: "Rumania",
        fr: "Roumanie",
        it: "Romania",
        nl: "Roemenië",
    },
    RUS: {
        en: "Russia",
        de: "Russland",
        es: "Rusia",
        fr: "Russie",
        it: "Russia",
        nl: "Rusland",
    },
    SAU: {
        en: "Saudi Arabia",
        de: "Saudi-Arabien",
        es: "Arabia Saudí",
        fr: "Arabie saoudite",
        it: "Arabia Saudita",
        nl: "Saudi-Arabië",
    },
    SGP: {
        en: "Singapore",
        de: "Singapore",
        es: "Singapore",
        fr: "Singapore",
        it: "Singapore",
        nl: "Singapore",
    },
    SLV: {
        en: "El Salvador",
        de: EL_SALVADOR,
        es: EL_SALVADOR,
        fr: EL_SALVADOR,
        it: EL_SALVADOR,
        nl: EL_SALVADOR,
    },
    SRB: {
        en: "Serbia",
        de: "Serbien",
        es: "Serbia",
        fr: "Serbie",
        it: "Serbia",
        nl: "Servië",
    },
    SVK: {
        en: "Slovak Republic",
        de: "Slowakische Republik",
        es: "República Eslovaca",
        fr: "République slovaque",
        it: "Repubblica Slovacca",
        nl: "Slowaakse Republiek",
    },
    SVN: {
        en: "Slovenia",
        de: "Slowenien",
        es: "Eslovenia",
        fr: "Slovénie",
        it: "Slovenia",
        nl: "Slovenië",
    },
    SWE: {
        en: "Sweden",
        de: "Schweden",
        es: "Suecia",
        fr: "Suède",
        it: "Svezia",
        nl: "Zweden",
    },
    THA: {
        en: "Thailand",
        de: "Thailand",
        es: "Tailandia",
        fr: "Thaïlande",
        it: "Thailandia",
        nl: "Thailand",
    },
    TUR: {
        en: "Turkey",
        de: "Türkei",
        es: "Turquía",
        fr: "Turquie",
        it: "Turchia",
        nl: "Turkije",
    },
    UGA: {
        en: "Uganda",
        de: "Uganda",
        es: "Uganda",
        fr: "Ouganda",
        it: "Uganda",
        nl: "Oeganda",
    },
    UKR: {
        en: "Ukraine",
        de: "Ukraine",
        es: "Ucrania",
        fr: "Ukraine",
        it: "Ucraina",
        nl: "Oekraïne",
    },
    URY: {
        en: "Uruguay",
        de: "Uruguay",
        es: "Uruguay",
        fr: "Uruguay",
        it: "Uruguay",
        nl: "Uruguay",
    },
    USA: {
        en: "United States",
        de: "Vereinigten Staaten",
        es: "Estados Unidos",
        fr: "États-Unis",
        it: "Stati Uniti",
        nl: "Verenigde Staten",
    },
    VNM: {
        en: "Vietnam",
        de: "Vietnam",
        es: "Vietnam",
        fr: "Vietnam",
        it: "Vietnam",
        nl: "Vietnam",
    },
    ZAF: {
        en: "South Africa",
        de: "Südafrika",
        es: "Sudáfrica",
        fr: "Afrique du Sud",
        it: "Sudafrica",
        nl: "Zuid-Afrika",
    },
};
